import { render } from "./QaTestReportBoard.vue?vue&type=template&id=0edaee26&scoped=true"
import script from "./QaTestReportBoard.vue?vue&type=script&lang=js"
export * from "./QaTestReportBoard.vue?vue&type=script&lang=js"

import "./QaTestReportBoard.vue?vue&type=style&index=0&id=0edaee26&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edaee26"]])

export default __exports__